import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ReactElement, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BusinessIcon from "@mui/icons-material/Business";
import LocalConvenienceStoreIcon from "@mui/icons-material/LocalConvenienceStore";
import ChecklistIcon from "@mui/icons-material/Checklist";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import InventoryIcon from "@mui/icons-material/Inventory";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import ROUTES from "../../eums/route";

interface ISideMenu {
  userRole: UserRole;
  drawerWidth?: number;
}

const items: {
  label: string;
  icon: ReactElement;
  path: string;
  roles: UserRole[];
}[] = [
  {
    label: "Dashboard",
    icon: <DashboardIcon />,
    path: ROUTES.ROOT,
    roles: ["maintainer", "master", "owner"],
  },
  {
    label: "Map",
    icon: <DashboardIcon />,
    path: ROUTES.MAP,
    roles: ["maintainer", "master", "owner"],
  },
  {
    label: "Service Orders",
    icon: <SettingsSuggestIcon />,
    path: ROUTES.SERVICE_ORDERS,
    roles: ["maintainer", "master", "owner"],
  },
  {
    label: "Clients",
    icon: <BusinessIcon />,
    path: ROUTES.CLIENTS_LIST,
    roles: ["master", "owner"],
  },
  {
    label: "Companies",
    icon: <LocalConvenienceStoreIcon />,
    path: ROUTES.COMPANIES_LIST,
    roles: ["master"],
  },
  {
    label: "Workers",
    icon: <ManageAccountsIcon />,
    path: ROUTES.WORKERS_LIST,
    roles: ["maintainer", "master", "owner"],
  },
  {
    label: "Inspection Checklist",
    icon: <ChecklistIcon />,
    path: ROUTES.INSPECTION_CHECKLIST,
    roles: ["maintainer", "master", "owner"],
  },
  {
    label: "Prices",
    icon: <CurrencyPoundIcon />,
    path: ROUTES.PRICES_CONFIG,
    roles: ["master", "owner"],
  },
  {
    label: "Inventory",
    icon: <InventoryIcon />,
    path: ROUTES.MATERIAL_LIST,
    roles: ["master", "owner"],
  },
];

const SideMenu = ({ userRole, drawerWidth = 240 }: ISideMenu) => {
  const navigate = useNavigate();

  const goTo = useCallback((path: string) => {
    navigate(path);
  }, []);

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        paddingTop: 24,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          paddingTop: 8,
        },
      }}
    >
      <List component="nav">
        {items.map(({ label, icon, path }) => (
          <ListItemButton onClick={() => goTo(path)}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={label} />
          </ListItemButton>
        ))}
      </List>
    </Drawer>
  );
};

export default SideMenu;
